import { Form, Input, Modal, Select } from 'antd';
import { useEffect } from 'react';

interface FrozenConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (values: { frozenDuration: number; frozenReason: string }) => void;
}

const FrozenConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
}: FrozenConfirmDialogProps) => {
  const [form] = Form.useForm<{
    frozenDuration: number;
    frozenReason: string;
  }>();

  const handleOk = () => {
    const values = form.getFieldsValue();
    onConfirm(values);
  };

  useEffect(() => {
    form.resetFields();
  }, [isOpen, form]);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title="确定批量冻结?"
      okButtonProps={{
        type: 'primary',
        htmlType: 'submit',
        danger: true,
      }}
      destroyOnClose
      modalRender={(node) => (
        <Form layout="vertical" form={form} onFinish={handleOk}>
          {node}
        </Form>
      )}
    >
      <div>
        <div>被冻结用户将无法登录和使用APP，到期后自动恢复</div>
        <Form.Item
          label="冻结时长"
          name="frozenDuration"
          required
          rules={[{ required: true, message: '请选择冻结时长' }]}
        >
          <Select>
            <Select.Option value={1}>1天</Select.Option>
            <Select.Option value={3}>3天</Select.Option>
            <Select.Option value={7}>7天</Select.Option>
            <Select.Option value={14}>14天</Select.Option>
            <Select.Option value={30}>30天</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="冻结理由"
          name="frozenReason"
          required
          rules={[{ required: true, message: '请输入冻结理由' }]}
        >
          <Input.TextArea rows={4} maxLength={200} />
        </Form.Item>
      </div>
    </Modal>
  );
};

export default FrozenConfirmDialog;
